import defaultAxios from "lib/http/http.common"
import {LoraDeviceResponse} from "dto/loradevice/lora-device"
import {ApiResponse} from "api/common/response"

const findAllLoraDevice = async (page: number, pageSize: number, search: string = "") => {
    // const response = await defaultAxios.get<ApiResponse<LoraDeviceResponse>>(`/lora/device?page=${page}&size=${pageSize}`)
    const offset = page * pageSize
    const response = await defaultAxios.get<ApiResponse<LoraDeviceResponse>>(`/lora/device?offset=${offset}&limit=${pageSize}&search=${search}`)
    return response.data
}

export const LoraDeviceApi = {
    findAllLoraDevice,
}
